import {useContext} from 'react';

import {Loading} from './Loading';
import {LoadingContext} from '../../contexts/LoadingContext/LoadingContext';

export const LoadingOverlay = () => {
  const {loading} = useContext(LoadingContext);

  if (loading) {
    return <Loading backDrop />;
  }
  return null;
};
